import httpClient from "./httpClient";

const deleteApiData = async (url) => {
  try {
    const response = await httpClient.delete(url);
    return response;
  } catch (error) {
    console.error("Error:", error);
  }
};

export default deleteApiData;
